import { useEffect, useState } from 'react';
import { IClientFull, useGetClientInfoQuery } from 'src/redux/services/clients';
import { CustomTypography } from '../custom/CustomTypography';
import { ClientSettings } from './clientSettings/ClientSettings';
import { useParams } from 'react-router-dom';

const SettingsWrapperComponent = () => {
  const { appId = '', clientId = '' } = useParams<{ appId: string; clientId?: string }>();
  const [selectedClient, setSelectedClient] = useState<IClientFull | null>(null);
  const { data: fetchedClient } = useGetClientInfoQuery({ id: clientId || appId });

  useEffect(() => {
    if (fetchedClient) {
      setSelectedClient(fetchedClient);
    }
  }, [fetchedClient]);

  if (!selectedClient) {
    return <CustomTypography>Загрузка...</CustomTypography>;
  }

  return <>{clientId !== appId && <ClientSettings selectedClient={selectedClient} />}</>;
};

export const SettingsWrapper = SettingsWrapperComponent;
